import { z } from 'zod';

import { LoginId } from 'backend-client-web';

import { LoginSummary } from '../vaultContent/organizationLoginSummary/OrganizationLoginSummaryVaultContent';

type LoginSummaryUpdateMessageV1 = Record<LoginId, LoginSummary>;
const LoginSummaryUpdateMessageV1 = z.record(z.uuid(), LoginSummary);

export { LoginSummaryUpdateMessageV1 };
